export default function CTASection() {
  return (
    <section className="w-full flex flex-col md:flex-row min-h-[500px] md:min-h-[560px]">
      <div className="w-full md:w-1/2 relative overflow-hidden min-h-[300px] md:min-h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20view%20of%20curated%20fashion%20items%20circle%20arrangement%20including%20designer%20sneakers%20leather%20bag%20sunglasses%20and%20accessories%20on%20warm%20sand%20colored%20textured%20paper%20background%2C%20editorial%20magazine%20spread%20aesthetic%2C%20soft%20directional%20lighting%20creating%20artistic%20shadows%2C%20luxury%20brand%20campaign%20style&width=1000&height=800&seq=cta-v2-left&orientation=portrait"
          alt="Hoobuy Sheet - Links Oficiais"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="text-xs text-background-100/80 font-medium tracking-wider uppercase">Links Oficiais</span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight drop-shadow-lg">
            Hoobuy<br />Spreadsheet<br />2025
          </h2>
        </div>
      </div>

      <div className="w-full md:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-12 md:py-0 bg-background-50">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight mb-6">
            Acesse o Melhor<br />Spreadsheet da China
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
            Milhares de produtos verificados, atualizações constantes e os melhores finds de sneakers,
            streetwear e itens exclusivos diretamente das plataformas chinesas. Tudo organizado em um só lugar.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Acessar Agora
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}